export default __webpack_public_path__ + "static/media/Astro_sitting_playing_360.3c6b5ca4.png";